"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INVOICE_FORMATS = exports.InvoicePaymentMethod = exports.BlankableBillInvoiceFields = exports.InvoicePricingTypeModel = exports.DomesticDetailsValidationError = exports.AccountDetailsMissingError = exports.AccountDetailsValidatorError = exports.BillBankDetailsErrorType = exports.BillsAmlMaxSupplierPerMonth = exports.BillsAmlHighestPayment = exports.BillsAmlUsage = exports.SupplierStatus = exports.InvoiceFailureExportReason = exports.InvoiceFailureReason = exports.InvoiceStatus = void 0;
var InvoiceStatus;
(function (InvoiceStatus) {
    InvoiceStatus["RECEIVED"] = "RECEIVED";
    InvoiceStatus["PARSING"] = "PARSING";
    InvoiceStatus["PARSING_PENDING_HUMAN_REVIEW"] = "PARSING_PENDING_HUMAN_REVIEW";
    InvoiceStatus["PROCESSING_PARSING"] = "PROCESSING_PARSING";
    InvoiceStatus["PARSED"] = "PARSED";
    InvoiceStatus["MISSING_INFORMATION"] = "MISSING_INFORMATION";
    InvoiceStatus["PENDING_APPROVAL"] = "PENDING_APPROVAL";
    InvoiceStatus["READY"] = "READY";
    InvoiceStatus["SCHEDULED"] = "SCHEDULED";
    InvoiceStatus["PREPARING"] = "PREPARING";
    InvoiceStatus["PREPARED"] = "PREPARED";
    InvoiceStatus["PAYMENT_IN_PROGRESS"] = "PAYMENT_IN_PROGRESS";
    InvoiceStatus["PAID"] = "PAID";
    InvoiceStatus["MARKED_AS_PAID"] = "MARKED_AS_PAID";
    InvoiceStatus["REJECTED_BY_USER"] = "REJECTED_BY_USER";
    InvoiceStatus["VOIDED_BY_USER"] = "VOIDED_BY_USER";
    InvoiceStatus["FAILED_INTERNAL_VALIDATION"] = "FAILED_INTERNAL_VALIDATION";
    InvoiceStatus["FAILED_PAYMENT"] = "FAILED_PAYMENT";
    InvoiceStatus["FAILED"] = "FAILED";
    InvoiceStatus["REJECTED_BY_APPROVER"] = "REJECTED_BY_APPROVER";
})(InvoiceStatus = exports.InvoiceStatus || (exports.InvoiceStatus = {}));
var InvoiceFailureReason;
(function (InvoiceFailureReason) {
    InvoiceFailureReason["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    InvoiceFailureReason["DUPLICATE_FILE"] = "DUPLICATE_FILE";
    InvoiceFailureReason["TECHNICAL_ERROR"] = "TECHNICAL_ERROR";
    InvoiceFailureReason["FAILED_INTERNAL_VALIDATION"] = "FAILED_INTERNAL_VALIDATION";
    InvoiceFailureReason["BLOCKED_SUPPLIER"] = "BLOCKED_SUPPLIER";
    InvoiceFailureReason["PAYMENT_RETURNED"] = "PAYMENT_RETURNED";
    InvoiceFailureReason["INCORRECT_BANK_DETAILS"] = "INCORRECT_BANK_DETAILS";
    InvoiceFailureReason["INVALID_DOCUMENT_TYPE"] = "INVALID_DOCUMENT_TYPE";
    InvoiceFailureReason["MISSING_ENTITLEMENT"] = "MISSING_ENTITLEMENT";
    InvoiceFailureReason["PAYMENT_EXPIRED"] = "PAYMENT_EXPIRED";
    InvoiceFailureReason["MISSING_APPROVAL"] = "MISSING_APPROVAL";
})(InvoiceFailureReason = exports.InvoiceFailureReason || (exports.InvoiceFailureReason = {}));
// Duplicated from src/lib/services/bill-invoice/index.ts
// To use when defining new contracts in api/contract
var InvoiceFailureExportReason;
(function (InvoiceFailureExportReason) {
    /** Each time a new connection is created we create a pleo bank account, if the user deletes or archives that bank account this error will throw **/
    InvoiceFailureExportReason["PLEO_BANK_ACCOUNT_MISSING_EXCEPTION"] = "PLEO_BANK_ACCOUNT_MISSING_EXCEPTION";
    /** If the user tries to export using an account that was either deleted or archived **/
    InvoiceFailureExportReason["ARCHIVED_OR_DELETED_ACCOUNT_NUMBER_EXCEPTION"] = "ARCHIVED_OR_DELETED_ACCOUNT_NUMBER_EXCEPTION";
    /** Contact names (supplier, customer) are unique at the organization level **/
    InvoiceFailureExportReason["XERO_CONTACT_NAME_EXISTS"] = "XERO_CONTACT_NAME_EXISTS";
    /** If the user tries to export using a non existent account number **/
    InvoiceFailureExportReason["INVALID_ACCOUNT_NUMBER_EXCEPTION"] = "INVALID_ACCOUNT_NUMBER_EXCEPTION";
    /** Xero allows export to foreign currencies only if you have the paid plan if thats the case the user should go to the organization settings -> currencies and then add the currency from there **/
    InvoiceFailureExportReason["XERO_ORGANISATION_NOT_SUBSCRIBED_CURRENCY"] = "XERO_ORGANISATION_NOT_SUBSCRIBED_CURRENCY";
    /** The user is not connected to the integration **/
    InvoiceFailureExportReason["UNAUTHENTICATED_EXCEPTION"] = "UNAUTHENTICATED_EXCEPTION";
    /** The connection with the integration has been broken, the user has to go and re-enable the connection **/
    InvoiceFailureExportReason["TOKEN_INVALIDATED"] = "TOKEN_INVALIDATED";
    /** It happens when trying to export to a nonexistent xero supplier, this can happen for example when a user chooses a supplier for the export phase and then deletes that contact from Xero - this can be solved by just picking another supplier from the contact list **/
    InvoiceFailureExportReason["INVALID_XERO_SUPPLIER_ID"] = "INVALID_XERO_SUPPLIER_ID";
    /** In case we send the pleo internal account id or externalAccountId and is not found in IO, this could happen if the user updated their accounts and the change wasn't reflected at pleo at the moment of the export, to fix this we just have to pull the list of accounts again and ask the user to select another account number **/
    InvoiceFailureExportReason["INTERNAL_ACCOUNT_PLEO_ID_NOT_FOUND"] = "INTERNAL_ACCOUNT_PLEO_ID_NOT_FOUND";
    /** Other reason not described above **/
    InvoiceFailureExportReason["FAILED"] = "FAILED";
})(InvoiceFailureExportReason = exports.InvoiceFailureExportReason || (exports.InvoiceFailureExportReason = {}));
var SupplierStatus;
(function (SupplierStatus) {
    SupplierStatus["DRAFT"] = "DRAFT";
    SupplierStatus["INCORRECT_BANK_DETAILS"] = "INCORRECT_BANK_DETAILS";
    SupplierStatus["UNVERIFIED"] = "UNVERIFIED";
    SupplierStatus["REQUIRES_VERIFICATION"] = "REQUIRES_VERIFICATION";
    SupplierStatus["VERIFIED"] = "VERIFIED";
    SupplierStatus["BLOCKED"] = "BLOCKED";
    SupplierStatus["DEPRECATED"] = "DEPRECATED";
})(SupplierStatus = exports.SupplierStatus || (exports.SupplierStatus = {}));
var BillsAmlUsage;
(function (BillsAmlUsage) {
    BillsAmlUsage["GOODS"] = "GOODS";
    BillsAmlUsage["SERVICES"] = "SERVICES";
    BillsAmlUsage["BOTH"] = "BOTH";
})(BillsAmlUsage = exports.BillsAmlUsage || (exports.BillsAmlUsage = {}));
var BillsAmlHighestPayment;
(function (BillsAmlHighestPayment) {
    BillsAmlHighestPayment["GBP_5000"] = "GBP_5000";
    BillsAmlHighestPayment["GBP_15000"] = "GBP_15000";
    BillsAmlHighestPayment["GBP_25000"] = "GBP_25000";
    BillsAmlHighestPayment["GBP_MORE"] = "GBP_MORE";
})(BillsAmlHighestPayment = exports.BillsAmlHighestPayment || (exports.BillsAmlHighestPayment = {}));
var BillsAmlMaxSupplierPerMonth;
(function (BillsAmlMaxSupplierPerMonth) {
    BillsAmlMaxSupplierPerMonth["MAX_5"] = "MAX_5";
    BillsAmlMaxSupplierPerMonth["MAX_10"] = "MAX_10";
    BillsAmlMaxSupplierPerMonth["MORE_THAN_10"] = "MORE_THAN_10";
})(BillsAmlMaxSupplierPerMonth = exports.BillsAmlMaxSupplierPerMonth || (exports.BillsAmlMaxSupplierPerMonth = {}));
var BillBankDetailsErrorType;
(function (BillBankDetailsErrorType) {
    BillBankDetailsErrorType["SEMANTIC"] = "SEMANTIC";
    BillBankDetailsErrorType["ALL_MISSING"] = "ALL_MISSING";
    BillBankDetailsErrorType["BIC"] = "BIC";
    BillBankDetailsErrorType["DOMESTIC"] = "DOMESTIC";
    BillBankDetailsErrorType["MISSING_FIELD"] = "MISSING_FIELD";
})(BillBankDetailsErrorType = exports.BillBankDetailsErrorType || (exports.BillBankDetailsErrorType = {}));
var AccountDetailsValidatorError;
(function (AccountDetailsValidatorError) {
    AccountDetailsValidatorError["BIC_COUNTRY_INVALID"] = "BIC_COUNTRY_INVALID";
    AccountDetailsValidatorError["BIC_COUNTRY_MISMATCH"] = "BIC_COUNTRY_MISMATCH";
    AccountDetailsValidatorError["BIC_INSTITUTION_INVALID_CHARS"] = "BIC_INSTITUTION_INVALID_CHARS";
    AccountDetailsValidatorError["BIC_LENGTH_INVALID"] = "BIC_LENGTH_INVALID";
    AccountDetailsValidatorError["BIC_LOCATION_INVALID_CHARS"] = "BIC_LOCATION_INVALID_CHARS";
    AccountDetailsValidatorError["IBAN_INVALID"] = "IBAN_INVALID";
    AccountDetailsValidatorError["IBAN_COUNTRY_INVALID"] = "IBAN_COUNTRY_INVALID";
    AccountDetailsValidatorError["IBAN_LENGTH_INVALID"] = "IBAN_LENGTH_INVALID";
    AccountDetailsValidatorError["IBAN_CHECKSUM_INVALID"] = "IBAN_CHECKSUM_INVALID";
    AccountDetailsValidatorError["IBAN_COUNTRY_MISMATCH"] = "IBAN_COUNTRY_MISMATCH";
    AccountDetailsValidatorError["DOMESTIC_ACCOUNT_NUMBER_LENGTH_INVALID"] = "DOMESTIC_ACCOUNT_NUMBER_LENGTH_INVALID";
    AccountDetailsValidatorError["DOMESTIC_ACCOUNT_NUMBER_REGEX_FAILED"] = "DOMESTIC_ACCOUNT_NUMBER_REGEX_FAILED";
    AccountDetailsValidatorError["DOMESTIC_BANK_CODE_LENGTH_INVALID"] = "DOMESTIC_BANK_CODE_LENGTH_INVALID";
    AccountDetailsValidatorError["DOMESTIC_BANK_CODE_REGEX_FAILED"] = "DOMESTIC_BANK_CODE_REGEX_FAILED";
})(AccountDetailsValidatorError = exports.AccountDetailsValidatorError || (exports.AccountDetailsValidatorError = {}));
var AccountDetailsMissingError;
(function (AccountDetailsMissingError) {
    AccountDetailsMissingError["COUNTRY_CODE"] = "COUNTRY_CODE";
    AccountDetailsMissingError["BIC"] = "BIC";
    AccountDetailsMissingError["IBAN"] = "IBAN";
    AccountDetailsMissingError["BANK_CODE"] = "BANK_CODE";
    AccountDetailsMissingError["ACCOUNT_NUMBER"] = "ACCOUNT_NUMBER";
})(AccountDetailsMissingError = exports.AccountDetailsMissingError || (exports.AccountDetailsMissingError = {}));
var DomesticDetailsValidationError;
(function (DomesticDetailsValidationError) {
    DomesticDetailsValidationError["SORT_CODE_INVALID"] = "SORT_CODE_INVALID";
})(DomesticDetailsValidationError = exports.DomesticDetailsValidationError || (exports.DomesticDetailsValidationError = {}));
var InvoicePricingTypeModel;
(function (InvoicePricingTypeModel) {
    InvoicePricingTypeModel["SUPPLIER_PAYMENT"] = "SUPPLIER_PAYMENT";
    InvoicePricingTypeModel["CURRENCY_MARGIN"] = "CURRENCY_MARGIN";
    /**
     * @deprecated Deprecated due to PEG-3170
     */
    InvoicePricingTypeModel["INTERNATIONAL_TRANSFER_FEE"] = "INTERNATIONAL_TRANSFER_FEE";
})(InvoicePricingTypeModel = exports.InvoicePricingTypeModel || (exports.InvoicePricingTypeModel = {}));
var BlankableBillInvoiceFields;
(function (BlankableBillInvoiceFields) {
    BlankableBillInvoiceFields["INVOICE_DATE"] = "INVOICE_DATE";
    BlankableBillInvoiceFields["SUPPLIER_IBAN"] = "SUPPLIER_IBAN";
    BlankableBillInvoiceFields["SUPPLIER_ADDRESS_COUNTRY_CODE"] = "SUPPLIER_ADDRESS_COUNTRY_CODE";
    BlankableBillInvoiceFields["AMOUNT"] = "AMOUNT";
    BlankableBillInvoiceFields["VAT_AMOUNT"] = "VAT_AMOUNT";
    BlankableBillInvoiceFields["DUE_AT"] = "DUE_AT";
    BlankableBillInvoiceFields["CURRENCY"] = "CURRENCY";
})(BlankableBillInvoiceFields = exports.BlankableBillInvoiceFields || (exports.BlankableBillInvoiceFields = {}));
var InvoicePaymentMethod;
(function (InvoicePaymentMethod) {
    InvoicePaymentMethod["DIRECT_DEBIT"] = "DIRECT_DEBIT";
    InvoicePaymentMethod["CREDIT_CARD"] = "CREDIT_CARD";
    InvoicePaymentMethod["BANK_ACCOUNT"] = "BANK_ACCOUNT";
    InvoicePaymentMethod["OTHER"] = "OTHER";
})(InvoicePaymentMethod = exports.InvoicePaymentMethod || (exports.InvoicePaymentMethod = {}));
/* eslint-disable prettier/prettier */
exports.INVOICE_FORMATS = [
    { mime: 'image/gif', extension: 'gif' },
    { mime: 'image/jpeg', extension: 'jpg' },
    { mime: 'image/pjpeg', extension: 'pjpg' },
    { mime: 'image/png', extension: 'png' },
    { mime: 'image/tiff', extension: 'tiff' },
    { mime: 'image/tiff', extension: 'tif' },
    { mime: 'application/pdf', extension: 'pdf' },
    { mime: 'image/heic', extension: 'heic' },
    { mime: 'image/heif', extension: 'heif' },
    { mime: 'application/msword', extension: 'doc' },
    { mime: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', extension: 'docx' },
    { mime: 'application/vnd.openxmlformats-officedocument.wordprocessingml.template', extension: 'dotx' },
    { mime: 'application/vnd.ms-word.document.macroEnabled.12', extension: 'docm' },
    { mime: 'application/vnd.ms-word.template.macroEnabled.12', extension: 'dotm' },
    { mime: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', extension: 'xlsx' },
    { mime: 'application/vnd.openxmlformats-officedocument.spreadsheetml.template', extension: 'xltx' },
    { mime: 'application/vnd.ms-excel.sheet.macroEnabled.12', extension: 'xlsm' },
    { mime: 'application/vnd.ms-excel.template.macroEnabled.12', extension: 'xltm' },
    { mime: 'application/vnd.ms-excel.addin.macroEnabled.12', extension: 'xlam' },
    { mime: 'application/vnd.ms-excel.sheet.binary.macroEnabled.12', extension: 'xlsb' },
    { mime: 'application/vnd.ms-powerpoint', extension: 'ppt' },
    { mime: 'application/vnd.openxmlformats-officedocument.presentationml.presentation', extension: 'pptx' },
    { mime: 'application/vnd.openxmlformats-officedocument.presentationml.template', extension: 'potx' },
    { mime: 'application/vnd.openxmlformats-officedocument.presentationml.slideshow', extension: 'ppsx' },
    { mime: 'application/vnd.ms-powerpoint.addin.macroEnabled.12', extension: 'ppam' },
    { mime: 'application/vnd.ms-powerpoint.presentation.macroEnabled.12', extension: 'pptm' },
    { mime: 'application/vnd.ms-powerpoint.template.macroEnabled.12', extension: 'potm' },
    { mime: 'application/vnd.ms-powerpoint.slideshow.macroEnabled.12', extension: 'ppsm' },
    { mime: 'application/vnd.oasis.opendocument.text', extension: 'odt' },
    { mime: 'application/vnd.oasis.opendocument.spreadsheet', extension: 'ods' },
    { mime: 'application/vnd.oasis.opendocument.presentation', extension: 'odp' },
];
//# sourceMappingURL=bill-invoice.js.map